// TooltipWrapper.tsx
import React, { useState, cloneElement } from 'react';

import { Tooltip } from './Tooltip'; // Import your Tooltip component

interface TooltipWrapperProps {
  position: 'top' | 'right' | 'bottom' | 'left' | 'auto';
  tooltipContent: React.ReactNode; // Content to be shown inside the tooltip
  children: React.ReactElement; // Expect a single React element as a child
  allowWrap?: boolean;
  customClass?: string; // Optional custom class for styling
  tooltipContentId?: string;
}

export const TooltipWrapper: React.FC<TooltipWrapperProps> = ({
  position,
  tooltipContent,
  children,
  customClass,
  allowWrap = false,
  tooltipContentId = 'tooltipContentId',
}) => {
  const [isVisible, setIsVisible] = useState(false);

  // Clone the child element to attach event listeners without altering its original functionality
  const triggerElement = cloneElement(children, {
    onMouseEnter: () => setIsVisible(true),
    onMouseLeave: () => setIsVisible(false),
    onFocus: () => setIsVisible(true),
    onBlur: () => setIsVisible(false),
    'aria-describedby': tooltipContentId, // Accessibility: Describes the element that the button controls
  });

  return (
    <>
      {triggerElement}
      {isVisible && (
        <Tooltip
          position={position}
          visible={isVisible}
          allowWrap={allowWrap}
          customClass={customClass}
        >
          <div id={tooltipContentId}>{tooltipContent}</div>
        </Tooltip>
      )}
    </>
  );
};
